var CIDSerialiser = require('conversation/conversation-id-serialiser');
var Codec = require('io/codec');

module.exports = {
    read : function(bis) {
        return {
            cid : CIDSerialiser.read(bis),
            path : bis.readString(),
            bytes : bis.readBytes()
        };
    },
    write : function(bos, req) {
        CIDSerialiser.write(bos, req.cid);
        Codec.writeString(bos, req.path);
        Codec.writeBytes(bos, req.bytes);
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/topic-update/update-source-set-request-serialiser.js
// module id = 1078
// module chunks = 0